import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismMessage } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import GeneralNavigationIntercomHelpLink from 'lumen/components/general/navigation/intercom-help-link';

interface HotelAndMarketRevenueInsightPickUpPaceEmptyStateSignature {
  Args: {
    hasPickup: boolean;
  };
  Element: HTMLElement;
}

export default class HotelAndMarketRevenueInsightPickUpPaceEmptyState extends Component<HotelAndMarketRevenueInsightPickUpPaceEmptyStateSignature> {
  @service declare riSelections: Services['ri-selections'];

  get descriptionKey(): string {
    if (this.args.hasPickup) {
      return 'revenue_insight.pickup_and_pace.incomplete';
    }

    return 'revenue_insight.pace_unavailable';
  }

  <template>
    <div class="flex items-center justify-center">
      <PrismMessage
        @description={{t
          this.descriptionKey
          integrationDate=this.riSelections.formattedIntegrationDate
        }}
        ...attributes
      >
        <:primaryAction>
          <span class="text-300--regular" slot="cta-link">
            <GeneralNavigationIntercomHelpLink
              @articleLink="en/articles/6949233-what-is-net"
              @iconName="link-out"
              @linkText={{t "general.learn_more"}}
              @type="text-and-icon"
            />
          </span>
        </:primaryAction>
      </PrismMessage>
    </div>
  </template>
}
